let singleton = null;
let singletonEnforcer = 'singletonEnforcer';

export default class Dimmed {
    constructor(enforcer) {
        if (enforcer !== singletonEnforcer) throw 'Cannot--construct singleton';
    }

    static get instance() {
        if (!singleton) singleton = new Dimmed(singletonEnforcer);
        return singleton;
    }

    init() {
        this.dimmed = document.querySelector('#nc-cnb .ncc-dimmed');

        if (!this.dimmed) {
            document.querySelector('#nc-cnb')?.insertAdjacentHTML('beforeend', '<div class="ncc-dimmed"></div>');
            this.dimmed = document.querySelector('#nc-cnb .ncc-dimmed');
        }

        ['touchstart', 'touchmove', 'touchend'].forEach(eventType => {
            this.dimmed?.addEventListener(eventType, e => {
                e.stopPropagation();
            });
        });

        this.dimmed?.addEventListener('click', e => {
            this.openClose(false);
            return false;
        });
    }

    openClose(_isOpen = true, _posi = 'left') {
        const body = document.querySelector('body');

        if (_isOpen) {
            const panel = document.querySelector(`.ncc-${_posi}-panel`);

            panel?.classList?.add('is-active');
            this.dimmed?.classList?.add('is-active-' + _posi);

            body.style.width = '100%';
            body.style.position = 'fixed';
            body.style.marginTop = `-${body.scrollTop}px`;
        } else {
            const panels = document.querySelectorAll('.ncc-left-panel, .ncc-right-panel, .ncc-character-panel');
            const lnbTitle = document.querySelector('.ncc-lnb-title--item');

            panels.forEach(v => {
                v?.classList?.remove('is-active');
            });
            this.dimmed?.classList?.remove(['is-active-left', 'is-active-right', 'is-active-title-submenu']);

            if(lnbTitle) {
                lnbTitle.style.display = 'none';
            }

            let mTop = Math.abs(body.style.marginTop.replace('px', ''));
            body.setAttribute('style', '');
            body.scrollTo(0, mTop);
        }

        if(_isOpen) {
            body?.classList?.add('ncc-dimmed');
        } else {
            body?.classList?.remove('ncc-dimmed');
        }

        this.dimmed?.dispatchEvent(new CustomEvent('open', {
            detail: {
                show: _isOpen,
                pos: _posi
            }
        }));
    }
}